"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIModalPanel = _interopRequireDefault(require("UIComponents/dialog/UIModalPanel"));

var _UIPanel = _interopRequireDefault(require("UIComponents/panel/UIPanel"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogHeaderImage = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeaderImage"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UIMediaRight = _interopRequireDefault(require("UIComponents/layout/UIMediaRight"));

var _UIPanelHeader = _interopRequireDefault(require("UIComponents/panel/UIPanelHeader"));

var _UIPanelSection = _interopRequireDefault(require("UIComponents/panel/UIPanelSection"));

var _UIPanelBody = _interopRequireDefault(require("UIComponents/panel/UIPanelBody"));

var _UIPanelFooter = _interopRequireDefault(require("UIComponents/panel/UIPanelFooter"));

var _PromptablePropInterface = _interopRequireDefault(require("UIComponents/decorators/PromptablePropInterface"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var propTypes = (0, _extends2.default)({
  allowHeader: _propTypes.default.bool.isRequired,
  bodyClassName: _propTypes.default.string,
  cancelHref: _propTypes.default.string,
  cancelTarget: _propTypes.default.string.isRequired,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  confirmAndAddLabel: _propTypes.default.string,
  confirmDisabled: _propTypes.default.bool,
  confirmDisabledTooltip: _propTypes.default.string,
  confirmHref: _propTypes.default.string,
  confirmLabel: _propTypes.default.node,
  confirmTarget: _propTypes.default.string.isRequired,
  confirmUse: _UIButton.default.propTypes.use,
  dialogClassName: _propTypes.default.string,
  extraFooter: _propTypes.default.node,
  extraRightAlignedFooter: _propTypes.default.node,
  footerAlign: _UIDialogFooter.default.propTypes.align,
  headerImage: _propTypes.default.string,
  headerImageOffsetBottom: _propTypes.default.number,
  headerImageOffsetTop: _propTypes.default.number,
  includeFooter: _propTypes.default.bool,
  isConfirmButtonLoading: _propTypes.default.bool,
  confirmProps: _propTypes.default.object,
  moreButtons: _propTypes.default.node,
  offsetTop: _propTypes.default.number,
  onCloseComplete: _propTypes.default.func,
  onConfirm: _propTypes.default.func,
  onOpenComplete: _propTypes.default.func,
  onReject: _propTypes.default.func.isRequired,
  onScroll: _propTypes.default.func,
  panelClassName: _propTypes.default.string,
  rejectLabel: _propTypes.default.node,
  showCancelButton: _propTypes.default.bool.isRequired,
  showCloseButton: _propTypes.default.bool.isRequired,
  showConfirmButton: _propTypes.default.bool.isRequired,
  showExtraFooterFirst: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['auto', 'medium', 'short', 'tall']),
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  use: _propTypes.default.oneOfType([_UIModal.default.propTypes.use, _propTypes.default.oneOf(['embedded', 'panel', 'sidebar'])]),
  width: _propTypes.default.number.isRequired
}, _PromptablePropInterface.default);
var defaultProps = {
  allowHeader: true,
  cancelTarget: '_self',
  confirmTarget: '_self',
  confirmUse: 'primary',
  footerAlign: 'left',
  includeFooter: true,
  isConfirmButtonLoading: false,
  onConfirm: _emptyFunction.default,
  onReject: _emptyFunction.default,
  onCloseComplete: _emptyFunction.default,
  showCancelButton: true,
  showCloseButton: true,
  showConfirmButton: true,
  showExtraFooterFirst: false,
  size: 'auto',
  use: 'default',
  width: 500
};

var EmbeddedComponent = function EmbeddedComponent(_ref) {
  var children = _ref.children;
  return _react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }
  }, children);
};

EmbeddedComponent.propTypes = {
  children: _propTypes.default.node
};

var BaseDialog =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(BaseDialog, _PureComponent);

  function BaseDialog() {
    (0, _classCallCheck2.default)(this, BaseDialog);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BaseDialog).apply(this, arguments));
  }

  (0, _createClass2.default)(BaseDialog, [{
    key: "getTitleNode",
    value: function getTitleNode() {
      var titleNode = this.props.title;

      if (typeof titleNode === 'string') {
        titleNode = _react.default.createElement("h3", {
          className: "m-all-0",
          key: "title-node"
        }, titleNode);
      }

      return titleNode;
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var closeButton;
      var _this$props = this.props,
          showCloseButton = _this$props.showCloseButton,
          onReject = _this$props.onReject,
          allowHeader = _this$props.allowHeader,
          use = _this$props.use;
      var titleNode = this.getTitleNode();
      var headerClasses = (0, _classnames.default)({
        'flex-shrink-0': use === 'embedded'
      });

      if (!showCloseButton && !titleNode) {
        return null;
      } // Most modals should have UIDialogCloseButton,
      // but we'll still include an escape hatch
      // for certain situations


      if (showCloseButton) {
        closeButton = _react.default.createElement(_UIDialogCloseButton.default, {
          key: "close-button",
          onClick: onReject,
          "data-selenium-test": "base-dialog-close-btn"
        });
      }

      if (!allowHeader) {
        return [titleNode, closeButton];
      }

      var Component = _UIDialogHeader.default;

      if (use === 'panel') {
        Component = _UIPanelHeader.default;
      }

      return _react.default.createElement(Component, {
        className: headerClasses
      }, titleNode, closeButton);
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          bodyClassName = _this$props2.bodyClassName,
          use = _this$props2.use;
      var isEmbedded = use === 'embedded';
      var bodyClasses = (0, _classnames.default)({
        'overflow-x-hidden': isEmbedded,
        'overflow-y-auto': isEmbedded,
        'p-bottom-0': isEmbedded
      }, bodyClassName);

      if (!children) {
        return null;
      }

      if (use === 'panel') {
        return _react.default.createElement(_UIPanelBody.default, null, _react.default.createElement(_UIPanelSection.default, null, children));
      }

      return _react.default.createElement(_UIDialogBody.default, {
        className: bodyClasses
      }, this.renderHeaderImage(), children);
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var _this$props3 = this.props,
          includeFooter = _this$props3.includeFooter,
          moreButtons = _this$props3.moreButtons,
          extraFooter = _this$props3.extraFooter,
          extraRightAlignedFooter = _this$props3.extraRightAlignedFooter,
          footerAlign = _this$props3.footerAlign,
          showExtraFooterFirst = _this$props3.showExtraFooterFirst,
          use = _this$props3.use;
      var confirmButton = this.renderConfirmButton();
      var cancelButton = this.renderCancelButton();
      var footerClasses = (0, _classnames.default)({
        'p-top-4': showExtraFooterFirst,
        'flex-shrink-0': use === 'embedded'
      });

      if (!includeFooter) {
        return null;
      }

      if (!(confirmButton || cancelButton || moreButtons || extraFooter)) {
        return null;
      }

      var Component = _UIDialogFooter.default;

      if (use === 'panel') {
        Component = _UIPanelFooter.default;
      }

      return _react.default.createElement(Component, {
        align: footerAlign,
        className: footerClasses
      }, _react.default.createElement(_UIMedia.default, {
        align: "center"
      }, _react.default.createElement(_UIMediaBody.default, null, showExtraFooterFirst && _react.default.createElement("div", {
        className: "p-left-1"
      }, extraFooter), _react.default.createElement(_UIList.default, {
        inline: true,
        className: "display-flex flex-wrap",
        childClassName: "p-bottom-1"
      }, confirmButton, moreButtons, cancelButton, !showExtraFooterFirst && extraFooter)), extraRightAlignedFooter && _react.default.createElement(_UIMediaRight.default, null, extraRightAlignedFooter)));
    }
  }, {
    key: "renderConfirmButton",
    value: function renderConfirmButton() {
      var style;
      var component;
      var _this$props4 = this.props,
          onConfirm = _this$props4.onConfirm,
          confirmHref = _this$props4.confirmHref,
          use = _this$props4.use,
          confirmUse = _this$props4.confirmUse,
          confirmDisabled = _this$props4.confirmDisabled,
          confirmLabel = _this$props4.confirmLabel,
          confirmDisabledTooltip = _this$props4.confirmDisabledTooltip,
          confirmTarget = _this$props4.confirmTarget,
          showConfirmButton = _this$props4.showConfirmButton,
          isConfirmButtonLoading = _this$props4.isConfirmButtonLoading,
          confirmProps = _this$props4.confirmProps;

      if (!showConfirmButton) {
        return null;
      }

      if (use === 'sidebar') {
        style = {
          float: 'right'
        };
      }

      var ButtonComponent = isConfirmButtonLoading ? _UILoadingButton.default : _UIButton.default;

      var button = _react.default.createElement(ButtonComponent, (0, _extends2.default)({
        onClick: onConfirm,
        style: style,
        href: confirmHref,
        target: confirmTarget,
        use: confirmUse,
        disabled: confirmDisabled,
        "data-selenium-test": "base-dialog-confirm-btn",
        "data-confirm-button": "accept"
      }, confirmProps), confirmLabel || _I18n.default.text('customerDataUiUtilities.BaseDialog.save'));

      if (confirmDisabledTooltip && confirmDisabled) {
        component = _react.default.createElement(_UITooltip.default, {
          title: confirmDisabledTooltip
        }, button);
      } else {
        component = button;
      }

      return component;
    }
  }, {
    key: "renderCancelButton",
    value: function renderCancelButton() {
      var style;
      var _this$props5 = this.props,
          onReject = _this$props5.onReject,
          cancelHref = _this$props5.cancelHref,
          use = _this$props5.use,
          rejectLabel = _this$props5.rejectLabel,
          cancelTarget = _this$props5.cancelTarget;

      if (!this.props.showCancelButton) {
        return null;
      }

      var clickHandler = {
        onClick: onReject
      };

      if (cancelHref) {
        clickHandler = {};
      }

      if (use === 'sidebar') {
        style = {
          float: 'right'
        };
      }

      return _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, clickHandler, {
        use: "secondary",
        style: style,
        href: cancelHref,
        target: cancelTarget,
        onClick: onReject
      }), rejectLabel || _I18n.default.text('customerDataUiUtilities.BaseDialog.cancel'));
    }
  }, {
    key: "renderHeaderImage",
    value: function renderHeaderImage() {
      var _this$props6 = this.props,
          headerImage = _this$props6.headerImage,
          headerImageOffsetTop = _this$props6.headerImageOffsetTop,
          headerImageOffsetBottom = _this$props6.headerImageOffsetBottom;

      if (!headerImage) {
        return null;
      }

      return _react.default.createElement(_UIDialogHeaderImage.default, {
        offsetTop: headerImageOffsetTop,
        offsetBottom: headerImageOffsetBottom
      }, _react.default.createElement(_UIImage.default, {
        src: headerImage,
        responsive: false
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var style;
      var _this$props7 = this.props,
          width = _this$props7.width,
          className = _this$props7.className,
          showCloseButton = _this$props7.showCloseButton,
          onReject = _this$props7.onReject,
          use = _this$props7.use,
          dialogClassName = _this$props7.dialogClassName,
          offsetTop = _this$props7.offsetTop,
          size = _this$props7.size,
          onOpenComplete = _this$props7.onOpenComplete,
          onScroll = _this$props7.onScroll,
          panelClassName = _this$props7.panelClassName,
          onCloseComplete = _this$props7.onCloseComplete;
      var extraProps;
      var Component;

      if (use === 'sidebar') {
        Component = _UIModalPanel.default;
        extraProps = {
          onEsc: showCloseButton ? onReject : undefined,
          onOpenComplete: onOpenComplete,
          onCloseComplete: onCloseComplete
        };
      } else if (use === 'panel') {
        Component = _UIPanel.default;
        extraProps = {
          panelClassName: panelClassName
        };
      } else if (use === 'embedded') {
        Component = EmbeddedComponent;
      } else {
        Component = _UIModal.default;
        extraProps = {
          onEsc: showCloseButton ? onReject : undefined,
          onOpenComplete: onOpenComplete,
          onCloseComplete: onCloseComplete
        };
      }

      if (offsetTop) {
        style = {
          marginTop: offsetTop + "px"
        };
      }

      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)('base-dialog', className),
        width: width,
        use: use,
        size: size,
        style: style,
        dialogClassName: dialogClassName,
        onScroll: onScroll
      }, extraProps), this.renderHeader(), this.renderBody(), this.renderFooter());
    }
  }]);
  return BaseDialog;
}(_PureComponent2.default);

BaseDialog.propTypes = propTypes;
BaseDialog.defaultProps = defaultProps;
var _default = BaseDialog;
exports.default = _default;
module.exports = exports.default;